<template>
  <div class="footer">
    <div class="footer-left">
      <img class="school-logo" src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/school-logo.png">
      <img class="school-logo" src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/college-logo.png">
      <div class="aws-logo">
        <svg t="1665476979155" class="icon" viewBox="0 0 1280 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2105" width="100" height="100"><path d="M360.82404 406.02c-1.44 45.3 21.2 65.36 21.76 78.1a16.328 16.328 0 0 1-8.2 12.54l-25.6 17.92a21.32 21.32 0 0 1-11.26 3.84c-0.86-0.04-16.38 3.66-40.96-51.22a157.216 157.216 0 0 1-125.22 58.9c-32.56 1.78-120.8-18.48-116.26-112.42-3.18-76.56 68.12-124.12 141.86-120.1 14.2 0.04 43.2 0.74 93.98 12.54v-31.24c5.38-52.92-29.4-93.98-89.62-87.82-4.8 0.02-38.8-1-91.68 20.22-14.72 6.76-16.6 5.64-21.5 5.64-14.82 0-8.72-42.96-5.88-48.4 10.42-12.8 71.72-36.7 131.88-36.36a153.714 153.714 0 0 1 111.38 34.56 140.57 140.57 0 0 1 35.34 104.72l-0.02 138.58zM187.98404 470.8c64.86-0.94 92.32-39.94 98.58-60.94 4.92-20.1 4.1-32.82 4.1-54.8-19.34-4.64-47.18-9.7-79.12-9.74-30.3-2.28-85.64 11.26-83.48 64.52-2.48 33.58 22.24 62.8 59.92 60.96z m341.84 46.1c-15.72 1.44-23.04-9.72-25.36-20.74l-99.6-329.3c-1.94-5.56-3.22-11.3-3.84-17.16a9.22 9.22 0 0 1 7.72-10.5c0.48-0.08-4.26 0 44.5 0 17.56-1.76 23.28 12.06 25.1 20.74l71.44 281.66 66.32-281.66c1.06-6.44 5.88-22.14 25.6-20.48h34.32c4.34-0.36 22.22-1 25.36 20.74l66.84 285.26L841.96404 160.2c0.96-4.36 5.44-22.74 25.36-20.74h39.44c1.7-0.26 12.3-1.62 10.5 17.16-0.86 3.7 6.82-21.32-105.5 339.8-2.3 11.02-9.64 22.18-25.36 20.74h-37.38c-21.88 2.3-25.02-19.32-25.36-21.5L657.34404 221.4l-65.56 273.98c-0.32 2.18-3.46 23.8-25.36 21.5h-36.6z m546.96 11.26c-11.76 0.02-67.84-0.6-114.72-24.58a25.604 25.604 0 0 1-15.62-23.82v-21.5c0-16.9 12.4-13.8 17.66-11.78 20.08 8.12 32.96 14.28 57.62 19.2 73.3 15.06 105.54-4.6 113.44-8.96 26.3-15.62 28.38-51.36 10.5-69.9-20.96-17.58-30.96-18.24-106.26-42-9.28-2.58-87.4-27.22-87.58-104.72-1.22-56.48 50.1-112.36 139.04-111.9 25.34-0.02 92.86 8.26 111.14 31.24 2.7 4.18 4.04 9.1 3.84 14.08v20.22c0 8.88-3.24 13.32-9.74 13.32-15.42-1.72-42.78-22.34-98.32-21.5-13.78-0.72-79.78 1.82-76.82 49.94-0.86 37.92 53.22 52.14 59.4 53.78 72.92 21.94 97.3 25.58 126.24 59.16 34.28 44.5 15.8 96.6 8.7 110.88-38.16 74.98-136.84 68.88-138.52 68.84z m80.4 209.72c-140.06 103.44-343.38 158.5-516.98 158.5A938.254 938.254 0 0 1 5.66404 654.92c-13.06-11.78-1.54-27.92 14.34-18.94a1274.74 1274.74 0 0 0 633.76 168.24 1260.44 1260.44 0 0 0 483.18-99.1c23.56-10 43.54 15.6 20.24 32.76z m58.38-66.58c-17.92-23.04-118.56-10.76-163.62-5.38-13.58 1.54-15.88-10.24-3.58-18.94 80.14-56.34 211.76-40.2 226.88-21.26 15.1 18.94-4.1 150.82-79.12 213.82-11.52 9.74-22.54 4.6-17.42-8.2 16.88-42.5 54.78-136.98 36.86-160.04z" fill="" p-id="2106"></path></svg>
      </div>
      <div class="bk-logo">
        <img src="https://static.igem.wiki/teams/4152/wiki/bk-logo.png">
      </div>
      <div class="idt-logo">
        <svg
            version="1.1"
            id="svg3410"
            xml:space="preserve"
            width="150"
            viewBox="0 0 600 170"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3414" /><g
            id="g3416"
            transform="translate(106.70694,-88.71331)"><g
       id="g3408"
       transform="translate(25.093059,-102.38669)"><path
         class="st0"
         d="m 95.3,360.5 v -26.1 h 5.4 c 3.9,0 6.7,0.3 8.5,0.9 2.5,0.9 4.5,2.4 5.9,4.6 1.4,2.2 2.1,4.8 2.1,7.8 0,2.6 -0.6,4.9 -1.7,6.9 -1.1,2 -2.6,3.5 -4.4,4.4 -1.8,1 -4.3,1.4 -7.6,1.4 h -8.2 z m 2.5,-2.4 h 3 c 3.6,0 6.1,-0.2 7.5,-0.7 2,-0.6 3.5,-1.8 4.6,-3.5 1.1,-1.7 1.7,-3.7 1.7,-6.1 0,-2.5 -0.6,-4.7 -1.8,-6.5 -1.2,-1.8 -2.9,-3 -5.1,-3.7 -1.6,-0.5 -4.3,-0.7 -8.1,-0.7 h -1.8 z"
         id="path3304"
          /><polygon
            class="st0"
            points="140,354.4 140,334.4 142.5,334.4 142.5,360.5 142,360.5 124.7,340.7 124.7,360.5 122,360.5 122,334.4 122.6,334.4 "
            id="polygon3306"
             /><path
            class="st0"
            d="m 158,334.4 12.2,26.1 h -2.8 l -4.1,-8.6 H 152 l -4.1,8.6 H 145 l 12.3,-26.1 z m -0.3,5.6 -4.5,9.5 h 8.9 z"
            id="path3308"
             /><rect
            x="-131.7"
            y="334.39999"
            class="st0"
            width="2.5999999"
            height="26.1"
            id="rect3310"
             /><polygon
            class="st0"
            points="-106.1,354.4 -106.1,334.4 -103.5,334.4 -103.5,360.5 -104.1,360.5 -121.3,340.7 -121.3,360.5 -124,360.5 -124,334.4 -123.5,334.4 "
            id="polygon3312"
             /><polygon
            class="st0"
            points="-84.2,337 -90,337 -90,360.5 -92.6,360.5 -92.6,337 -98.5,337 -98.5,334.4 -84.2,334.4 "
            id="polygon3314"
             /><polygon
            class="st0"
            points="-76.8,337 -76.8,345.1 -64.5,345.1 -64.5,347.7 -76.8,347.7 -76.8,358 -64.5,358 -64.5,360.5 -79.4,360.5 -79.4,334.4 -64.4,334.4 -64.4,337 "
            id="polygon3316"
             /><path
            class="st0"
            d="m -34.3,338.8 -2,1.9 c -1.5,-1.4 -3,-2.5 -4.8,-3.3 -1.7,-0.7 -3.4,-1.1 -5.1,-1.1 -2,0 -4,0.5 -5.8,1.5 -1.8,1 -3.3,2.4 -4.3,4.1 -1,1.7 -1.5,3.5 -1.5,5.5 0,2 0.5,3.8 1.6,5.6 1,1.8 2.5,3.2 4.4,4.2 1.9,1 3.9,1.5 6.1,1.5 2.7,0 5,-0.8 6.8,-2.3 1.9,-1.5 3,-3.5 3.3,-5.9 H -44 V 348 h 11.3 c 0,4 -1.2,7.2 -3.6,9.6 -2.4,2.4 -5.5,3.6 -9.5,3.6 -4.8,0 -8.6,-1.6 -11.4,-4.9 -2.2,-2.5 -3.2,-5.5 -3.2,-8.8 0,-2.5 0.6,-4.8 1.9,-6.9 1.2,-2.1 2.9,-3.8 5.1,-5 2.2,-1.2 4.6,-1.8 7.3,-1.8 2.2,0 4.3,0.4 6.2,1.2 1.9,0.7 3.8,2 5.6,3.8"
            id="path3318"
             /><path
            class="st0"
            d="m -28.8,334.4 h 5.2 c 2.9,0 4.9,0.1 5.9,0.3 1.5,0.4 2.8,1.1 3.8,2.3 1,1.2 1.4,2.6 1.4,4.3 0,1.4 -0.3,2.7 -1,3.8 -0.7,1.1 -1.6,1.9 -2.9,2.4 -1.2,0.5 -3,0.8 -5.1,0.8 l 9.4,12.1 h -3.2 l -9.4,-12.1 h -1.5 v 12.1 h -2.6 z m 2.6,2.6 v 8.9 h 4.5 c 1.7,0 3,-0.2 3.9,-0.5 0.8,-0.3 1.5,-0.9 2,-1.6 0.5,-0.7 0.7,-1.5 0.7,-2.4 0,-0.9 -0.2,-1.7 -0.7,-2.4 -0.5,-0.7 -1.1,-1.2 -1.9,-1.5 -0.8,-0.3 -2.1,-0.5 -3.8,-0.5 z"
            id="path3320"
             /><path
            class="st0"
            d="m 3.3,334.4 12.2,26.1 H 12.7 L 8.6,351.9 H -2.7 l -4.1,8.6 H -9.7 L 2.6,334.4 Z M 3,340 l -4.5,9.5 h 8.9 z"
            id="path3322"
             /><polygon
            class="st0"
            points="28.6,337 22.7,337 22.7,360.5 20.1,360.5 20.1,337 14.3,337 14.3,334.4 28.6,334.4 "
            id="polygon3324"
             /><polygon
            class="st0"
            points="36.2,337 36.2,345.1 48.5,345.1 48.5,347.7 36.2,347.7 36.2,358 48.5,358 48.5,360.5 33.6,360.5 33.6,334.4 48.6,334.4 48.6,337 "
            id="polygon3326"
             /><path
            class="st0"
            d="m 53.7,360.5 v -26.1 h 5.4 c 3.9,0 6.7,0.3 8.5,0.9 2.5,0.9 4.5,2.4 5.9,4.6 1.4,2.2 2.1,4.8 2.1,7.8 0,2.6 -0.6,4.9 -1.7,6.9 -1.1,2 -2.6,3.5 -4.4,4.4 -1.8,1 -4.3,1.4 -7.6,1.4 h -8.2 z m 2.5,-2.4 h 3 c 3.6,0 6.1,-0.2 7.5,-0.7 2,-0.6 3.5,-1.8 4.6,-3.5 1.1,-1.7 1.7,-3.7 1.7,-6.1 0,-2.5 -0.6,-4.7 -1.8,-6.5 -1.2,-1.8 -2.9,-3 -5.1,-3.7 -1.6,-0.5 -4.3,-0.7 -8.1,-0.7 h -1.8 z"
            id="path3328"
             /><polygon
            class="st0"
            points="198.2,337 192.4,337 192.4,360.5 189.8,360.5 189.8,337 184,337 184,334.4 198.2,334.4 "
            id="polygon3330"
             /><polygon
            class="st0"
            points="206.1,336.6 206.1,344.8 218.3,344.8 218.3,347.3 206.1,347.3 206.1,357.6 218.3,357.6 218.3,360.1 203.5,360.1 203.5,334 218.4,334 218.4,336.6 "
            id="polygon3332"
             /><path
            class="st0"
            d="m 248.1,339.2 -2.1,1.6 c -1.1,-1.5 -2.5,-2.6 -4.1,-3.4 -1.6,-0.8 -3.3,-1.1 -5.2,-1.1 -2.1,0 -4,0.5 -5.8,1.5 -1.8,1 -3.1,2.3 -4.1,4 -1,1.7 -1.5,3.6 -1.5,5.7 0,3.2 1.1,5.8 3.3,8 2.2,2.1 4.9,3.2 8.3,3.2 3.7,0 6.7,-1.4 9.2,-4.3 l 2.1,1.6 c -1.3,1.7 -2.9,2.9 -4.9,3.9 -1.9,0.9 -4.1,1.4 -6.5,1.4 -4.6,0 -8.2,-1.5 -10.8,-4.6 -2.2,-2.6 -3.3,-5.7 -3.3,-9.3 0,-3.8 1.3,-7 4,-9.6 2.7,-2.6 6,-3.9 10.1,-3.9 2.4,0 4.6,0.5 6.6,1.4 1.9,0.9 3.5,2.2 4.7,3.9"
            id="path3334"
             /><polygon
            class="st0"
            points="267.9,345.4 267.9,334.4 270.5,334.4 270.5,360.5 267.9,360.5 267.9,347.9 254.7,347.9 254.7,360.5 252,360.5 252,334.4 254.7,334.4 254.7,345.4 "
            id="polygon3336"
             /><polygon
            class="st0"
            points="293.5,354.4 293.5,334.4 296.1,334.4 296.1,360.5 295.5,360.5 278.3,340.7 278.3,360.5 275.6,360.5 275.6,334.4 276.2,334.4 "
            id="polygon3338"
             /><path
            class="st0"
            d="m 313.6,333.7 c 4,0 7.3,1.3 9.9,4 2.7,2.6 4,5.9 4,9.8 0,3.8 -1.3,7.1 -4,9.7 -2.7,2.7 -5.9,4 -9.7,4 -3.9,0 -7.1,-1.3 -9.8,-4 -2.7,-2.7 -4,-5.9 -4,-9.6 0,-2.5 0.6,-4.8 1.8,-7 1.2,-2.1 2.9,-3.8 5,-5 2.1,-1.3 4.4,-1.9 6.8,-1.9 m 0.1,2.6 c -1.9,0 -3.8,0.5 -5.5,1.5 -1.7,1 -3.1,2.4 -4.1,4.1 -1,1.7 -1.5,3.6 -1.5,5.7 0,3.1 1.1,5.7 3.2,7.9 2.2,2.1 4.7,3.2 7.8,3.2 2,0 3.9,-0.5 5.6,-1.5 1.7,-1 3.1,-2.3 4,-4 1,-1.7 1.4,-3.6 1.4,-5.7 0,-2.1 -0.5,-3.9 -1.4,-5.6 -1,-1.7 -2.3,-3 -4.1,-4 -1.6,-1.1 -3.4,-1.6 -5.4,-1.6"
            id="path3340"
             /><polygon
            class="st0"
            points="344.8,358 344.8,360.5 332.1,360.5 332.1,334.4 334.7,334.4 334.7,358 "
            id="polygon3342"
             /><path
            class="st0"
            d="m 359.5,333.7 c 4,0 7.3,1.3 9.9,4 2.7,2.6 4,5.9 4,9.8 0,3.8 -1.3,7.1 -4,9.7 -2.7,2.7 -5.9,4 -9.7,4 -3.9,0 -7.1,-1.3 -9.8,-4 -2.7,-2.7 -4,-5.9 -4,-9.6 0,-2.5 0.6,-4.8 1.8,-7 1.2,-2.1 2.9,-3.8 5,-5 2.1,-1.3 4.4,-1.9 6.8,-1.9 m 0.1,2.6 c -1.9,0 -3.8,0.5 -5.5,1.5 -1.7,1 -3.1,2.4 -4.1,4.1 -1,1.7 -1.5,3.6 -1.5,5.7 0,3.1 1.1,5.7 3.2,7.9 2.2,2.1 4.7,3.2 7.8,3.2 2,0 3.9,-0.5 5.6,-1.5 1.7,-1 3.1,-2.3 4,-4 1,-1.7 1.4,-3.6 1.4,-5.7 0,-2.1 -0.5,-3.9 -1.4,-5.6 -1,-1.7 -2.3,-3 -4.1,-4 -1.6,-1.1 -3.4,-1.6 -5.4,-1.6"
            id="path3344"
             /><path
            class="st0"
            d="m 403.6,338.8 -2,1.9 c -1.5,-1.4 -3.1,-2.5 -4.8,-3.3 -1.7,-0.7 -3.4,-1.1 -5.1,-1.1 -2,0 -4,0.5 -5.9,1.5 -1.8,1 -3.3,2.4 -4.3,4.1 -1,1.7 -1.5,3.5 -1.5,5.5 0,2 0.5,3.8 1.6,5.6 1.1,1.8 2.5,3.2 4.4,4.2 1.9,1 3.9,1.5 6.1,1.5 2.7,0 5,-0.8 6.8,-2.3 1.9,-1.5 3,-3.5 3.3,-5.9 h -8.3 V 348 h 11.3 c 0,4 -1.2,7.2 -3.6,9.6 -2.4,2.4 -5.5,3.6 -9.5,3.6 -4.8,0 -8.6,-1.6 -11.5,-4.9 -2.2,-2.5 -3.2,-5.5 -3.2,-8.8 0,-2.5 0.6,-4.8 1.9,-6.9 1.2,-2.1 3,-3.8 5.1,-5 2.2,-1.2 4.6,-1.8 7.3,-1.8 2.2,0 4.3,0.4 6.2,1.2 1.9,0.7 3.8,2 5.7,3.8"
            id="path3346"
             /><rect
            x="409"
            y="334.39999"
            class="st0"
            width="2.5999999"
            height="26.1"
            id="rect3348"
             /><polygon
            class="st0"
            points="419.1,337 419.1,345.1 431.3,345.1 431.3,347.7 419.1,347.7 419.1,358 431.3,358 431.3,360.5 416.5,360.5 416.5,334.4 431.4,334.4 431.4,337 "
            id="polygon3350"
             /><path
            class="st0"
            d="m 433.4,355.7 2.2,-1.3 c 1.6,2.9 3.4,4.3 5.4,4.3 0.9,0 1.7,-0.2 2.5,-0.6 0.8,-0.4 1.4,-1 1.7,-1.6 0.4,-0.7 0.6,-1.4 0.6,-2.2 0,-0.9 -0.3,-1.7 -0.9,-2.6 -0.8,-1.2 -2.3,-2.6 -4.5,-4.2 -2.2,-1.6 -3.5,-2.8 -4.1,-3.6 -0.9,-1.2 -1.4,-2.6 -1.4,-4 0,-1.1 0.3,-2.2 0.8,-3.1 0.5,-0.9 1.3,-1.7 2.3,-2.2 1,-0.5 2.1,-0.8 3.2,-0.8 1.2,0 2.4,0.3 3.5,0.9 1.1,0.6 2.2,1.7 3.4,3.4 l -2.1,1.6 c -1,-1.3 -1.8,-2.2 -2.5,-2.6 -0.7,-0.4 -1.5,-0.6 -2.3,-0.6 -1.1,0 -1.9,0.3 -2.6,1 -0.7,0.6 -1,1.4 -1,2.4 0,0.6 0.1,1.1 0.4,1.7 0.2,0.5 0.7,1.1 1.3,1.7 0.3,0.3 1.5,1.2 3.4,2.6 2.3,1.7 3.8,3.2 4.7,4.5 0.8,1.3 1.3,2.6 1.3,3.9 0,1.9 -0.7,3.5 -2.1,4.9 -1.4,1.4 -3.2,2.1 -5.2,2.1 -1.6,0 -3,-0.4 -4.3,-1.3 -1.4,-0.9 -2.6,-2.3 -3.7,-4.3"
            id="path3352"
             /><path
            class="st0"
            d="m 220.5,315 -4.3,-0.2 c -29.3,-1.3 -57.6,-25 -84.1,-49.1 -27.3,-25 -55.5,-50.8 -85.2,-53 -1.4,-0.1 -2.8,-0.2 -4.2,-0.2 -26.2,0 -50.9,19 -74,38.4 l -2.8,2.4 -2.6,-2.4 c -1.4,-1.3 -2.8,-2.6 -4.2,-3.8 l -3.2,-3.1 4.2,-3.8 c 26.1,-23.8 56.4,-49.1 87,-48.5 31.3,0.7 59.1,24.4 86.1,47.3 l 0.1,0.1 c 26.4,22.5 53.7,45.7 83.1,45.2 l 4.1,-0.1 z"
            id="path3354"
             /><path
            class="st1"
            d="m 216.4,191.8 c -23.1,0.2 -44.2,18.9 -64.6,37 -4.7,4.2 -9.6,8.5 -14.4,12.5 l -0.8,0.6 c 3.2,2.7 6.5,5.5 9.8,8.2 3.9,-3.4 7.9,-7.1 11.8,-10.7 18.6,-17.1 37.9,-34.8 58.4,-36 l 3.9,-0.2 v -11.5 z"
            id="path3356"
             /><rect
            x="236.5"
            y="191.8"
            class="st0"
            width="23.299999"
            height="123.3"
            id="rect3358"
             /><path
            class="st0"
            d="m 273.5,191.8 h 26.7 c 13.5,0 25.1,1.2 34.7,3.5 9.6,2.3 17.7,6.1 24.2,11.4 7.5,5.9 13,12.7 16.8,20.4 3.7,7.7 5.6,16.1 5.6,25.3 0,8.7 -1.7,16.8 -5,24.5 -3.4,7.6 -8.2,14.3 -14.7,20 -6.4,5.7 -14.3,10.2 -23.8,13.4 -9.4,3.3 -20.2,4.9 -32.4,4.9 h -32.1 z m 22,114.3 h 6.4 c 7.5,0 14.4,-1.1 21,-3.4 6.5,-2.3 12.2,-5.7 17,-10.2 4.8,-4.5 8.6,-10.1 11.4,-16.7 2.8,-6.6 4.2,-14.3 4.2,-23 0,-7.6 -1.3,-14.5 -4,-20.9 -2.7,-6.4 -6.3,-11.8 -11.1,-16.4 -4.7,-4.6 -10.4,-8.1 -16.9,-10.7 -6.6,-2.5 -13.7,-3.8 -21.5,-3.8 h -6.7 v 105.1 z"
            id="path3360"
             /><polygon
            class="st0"
            points="419.9,315.1 396.5,315.1 396.5,205.6 365.4,205.6 365.4,191.8 451,191.8 451,205.6 419.9,205.6 "
            id="polygon3362"
             /><path
            class="st0"
            d="m 454.5,198.6 c 0,-0.9 0.2,-1.8 0.5,-2.7 0.4,-0.8 0.9,-1.5 1.5,-2.2 0.6,-0.6 1.3,-1.1 2.2,-1.5 0.8,-0.4 1.7,-0.5 2.7,-0.5 0.9,0 1.8,0.2 2.7,0.5 0.8,0.4 1.5,0.9 2.2,1.5 0.6,0.6 1.1,1.3 1.5,2.2 0.4,0.8 0.5,1.7 0.5,2.7 0,0.9 -0.2,1.8 -0.5,2.7 -0.4,0.8 -0.8,1.5 -1.5,2.2 -0.6,0.6 -1.3,1.1 -2.2,1.5 -0.8,0.4 -1.7,0.5 -2.7,0.5 -0.9,0 -1.8,-0.2 -2.7,-0.5 -0.8,-0.4 -1.5,-0.9 -2.2,-1.5 -0.6,-0.6 -1.1,-1.3 -1.5,-2.2 -0.3,-0.8 -0.5,-1.7 -0.5,-2.7 m 1.2,0 c 0,0.8 0.1,1.5 0.4,2.2 0.3,0.7 0.7,1.3 1.2,1.8 0.5,0.5 1.1,0.9 1.8,1.2 0.7,0.3 1.4,0.4 2.2,0.4 0.8,0 1.5,-0.1 2.2,-0.4 0.7,-0.3 1.3,-0.7 1.8,-1.2 0.5,-0.5 0.9,-1.1 1.2,-1.8 0.3,-0.7 0.4,-1.4 0.4,-2.2 0,-0.8 -0.1,-1.5 -0.4,-2.2 -0.3,-0.7 -0.7,-1.3 -1.2,-1.8 -0.5,-0.5 -1.1,-0.9 -1.8,-1.2 -0.7,-0.3 -1.4,-0.4 -2.2,-0.4 -0.8,0 -1.5,0.2 -2.2,0.4 -0.7,0.3 -1.3,0.7 -1.8,1.2 -0.5,0.5 -0.9,1.1 -1.2,1.8 -0.3,0.7 -0.4,1.5 -0.4,2.2 m 3,-3.9 h 3 c 1,0 1.6,0.2 2.1,0.6 0.5,0.4 0.7,1 0.7,1.8 0,0.7 -0.2,1.2 -0.5,1.5 -0.4,0.3 -0.8,0.5 -1.3,0.6 l 2,3.3 h -1.5 l -1.9,-3.2 h -1 v 3.2 h -1.4 v -7.8 z m 1.4,3.4 h 1 c 0.2,0 0.4,0 0.7,0 0.2,0 0.4,-0.1 0.6,-0.1 0.2,-0.1 0.3,-0.2 0.4,-0.3 0.1,-0.1 0.2,-0.3 0.2,-0.6 0,-0.3 -0.1,-0.5 -0.2,-0.6 -0.1,-0.2 -0.2,-0.3 -0.4,-0.3 -0.2,-0.1 -0.4,-0.1 -0.6,-0.1 -0.2,0 -0.4,0 -0.7,0 h -1 z"
            id="path3364"
             /><path
            class="st1"
            d="m 119.4,257.7 c -23.1,19.8 -48,39.1 -75.5,39.1 h -0.3 c -28.1,-0.2 -53.3,-21 -77.7,-43.5 v 0 l -2.6,-2.4 c -1.4,-1.3 -2.8,-2.6 -4.2,-3.8 l -3.2,-3.1 v 0 c -25.8,-24.2 -52.4,-48.9 -83.1,-52.4 l -4.6,-0.5 v 31.8 l 3.9,0.2 c 29.7,1.5 56.8,25.1 83,47.8 28.2,24.5 54.8,47.7 85.5,47.7 1,0 2,0 3.1,-0.1 32.4,-1.7 61.5,-29.1 85,-51.1 l 2.6,-2.5 c -3.3,-3 -6.6,-6 -9.9,-8.9 z"
            id="path3366"
             /><path
            class="st0"
            d="m -59.9,258 c -4.7,4 -9.5,8.3 -14.1,12.5 -17.6,15.8 -35.7,32.2 -54.1,34.5 l -3.7,0.5 V 317 l 4.5,-0.3 c 22.3,-1.7 42.5,-19.3 62,-36.4 5.4,-4.7 10.5,-9.2 15.7,-13.3 l 0.1,-0.1 c -3.4,-3 -6.9,-6 -10.4,-8.9"
            id="path3368"
             /></g></g></svg>
        <img src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/yeasen.png">
      </div>
<!--      <div class="ys-logo">-->
<!--      </div>-->
    </div>
    <div class="footer-center">

    </div>
    <div class="footer-right">
      <div class="info">
        <div class="info-item">
          <img class="info-icon" src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/email.png" width="30" height="30">
          <p style="font-weight: bold">Email</p>
          <p>tjusls_china@163.com</p>
        </div>
        <div class="info-item">
          <img class="info-icon" src="https://static.igem.wiki/teams/4152/wiki/wiki-res/image/location.png" width="30" height="30">
          <p style="font-weight: bold">Address</p>
          <p>No.92 Weijin Road,Nankai District ,Tianjin, China</p>
        </div>
      </div>
      <div class="media-link">
        <div class="footer-icon-small wechat">
          <svg t="1665124661895" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2552" width="50" height="50"><path d="M690.1 377.4c5.9 0 11.8 0.2 17.6 0.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6 5.5 3.9 9.1 10.3 9.1 17.6 0 2.4-0.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-0.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-0.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4 0.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-0.1 17.8-0.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8z m-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1z m-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1z" p-id="2553"></path><path d="M866.7 792.7c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-0.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7 2.4 0 4.7-0.9 6.4-2.6 1.7-1.7 2.6-4 2.6-6.4 0-2.2-0.9-4.4-1.4-6.6-0.3-1.2-7.6-28.3-12.2-45.3-0.5-1.9-0.9-3.8-0.9-5.7 0.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9z m179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c-0.1 19.8-16.2 35.9-36 35.9z" p-id="2554"></path></svg>
        </div>

        <div class="footer-icon-small bilibili" @click="jumpBili()">
          <svg t="1665317259753" class="icon" viewBox="0 0 2299 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1844" width="50" height="50"><path d="M1775.840814 322.588002c6.0164 1.002733 53.144869-9.525967 55.150336-6.016401 3.0082 4.5123 24.065601 155.92504 18.550567 156.927774s-44.621635 10.027334-44.621635 10.027334c-3.0082-20.556034-28.577901-147.903173-29.079268-160.938707m75.205003-14.539634l20.556034 162.944174c10.5287-0.501367 53.144869-3.509567 57.155803-4.010934-6.0164-61.668103-16.545101-158.933241-16.545101-158.93324-20.054668-4.010934-41.112069-4.010934-61.166736 0m-40.610702 226.116376s92.752838-23.564234 126.344406-12.0328c17.046467 61.668103 48.131202 407.611118 51.139402 421.649386-21.057401 2.506833-90.246004 8.523234-95.761037 10.027333-4.5123-26.071068-81.72277-403.098818-81.722771-419.643919m343.436183-207.565809c5.515034 1.5041 54.648969-5.013667 55.150335-1.5041 1.002733 12.032801 6.0164 157.42914 0.501367 157.930507s-44.621635 4.010934-44.621635 4.010934c-1.002733-20.054668-12.032801-146.90044-11.030067-160.437341m75.70637-4.010933l4.010933 160.938707c10.5287 0 52.643502 2.506833 57.155803 2.005467-1.002733-61.668103 0-158.933241 0-158.933241-20.054668-3.509567-40.610702-5.013667-61.166736-4.010933m-64.676303 216.089043s94.758304-12.534167 126.845772 2.506833c7.019134 72.196803 6.0164 408.613852 7.019134 422.652119-21.558768 0-90.246004 1.002733-95.761038 2.005467-1.002733-26.071068-39.607968-410.619319-38.103868-427.164419m-220.099977-413.627519c54.648969 278.759879 96.262404 755.058234 97.766504 785.641602 0 0 43.117535 1.002733 91.750105 4.010934C2105.740095 614.383415 2070.644427 134.575493 2071.145794 119.033126c-12.032801-13.536901-126.344406 6.0164-126.344406 6.0164m-120.328005 659.297196c-10.5287-78.213204-290.291313-166.955108-447.720454-138.377206 0 0-19.553301-172.470141-27.073801-339.425248-6.517767-143.390873-1.002733-282.770813 0.501366-305.833681-10.5287-7.5205-123.837572 46.627102-185.004308 69.188603 0 0 73.199537 309.844614 126.344406 952.59671 0 0 84.730971 9.0246 230.12731-19.051934s317.365114-115.815705 302.825481-219.097244m-341.932083 140.88404l-24.566967-176.982441c6.0164-3.0082 156.927774 53.144869 172.971507 63.172203-2.506833 11.030067-148.40454 113.810238-148.40454 113.810238M610.664628 322.588002c6.0164 1.002733 53.144869-9.525967 55.150335-6.016401 3.0082 4.5123 24.065601 155.92504 18.550568 156.927774s-44.621635 10.027334-44.621635 10.027334c-3.0082-20.556034-28.577901-147.903173-29.079268-160.938707m75.205003-14.539634l20.556034 162.944174c10.5287-0.501367 53.144869-3.509567 57.155803-4.010934-6.517767-61.668103-16.545101-158.933241-16.545101-158.93324-20.054668-4.010934-41.112069-4.010934-61.166736 0m-40.610702 226.116376s92.752838-23.564234 126.344406-12.0328c17.046467 61.668103 48.131202 407.611118 51.139402 421.649386-21.057401 2.506833-90.246004 8.523234-95.761037 10.027333-4.5123-26.071068-81.72277-403.098818-81.722771-419.643919m343.436182-207.565809c5.515034 1.5041 54.648969-5.013667 55.150336-1.5041 1.002733 12.032801 6.0164 157.42914 0.501367 157.930507s-44.621635 4.010934-44.621635 4.010934c-1.002733-20.054668-11.531434-146.90044-11.030068-160.437341m75.706371-4.010933l4.010933 160.938707c10.5287 0 52.643502 2.506833 57.155803 2.005467-1.002733-61.668103 0-158.933241 0-158.933241-20.054668-3.509567-40.610702-4.5123-61.166736-4.010933m-64.676303 216.089043s94.758304-12.534167 126.845772 2.506833c7.019134 72.196803 6.0164 408.613852 7.019134 422.652119-21.558768 0-90.246004 1.002733-95.761038 2.005467-0.501367-26.071068-39.607968-410.619319-38.103868-427.164419m-220.099977-413.627519c54.648969 278.759879 96.262404 755.058234 97.766504 785.641602 0 0 43.117535 1.002733 91.750105 4.010934-28.577901-300.318647-63.67357-780.126569-63.172203-796.170303-12.032801-13.035534-126.344406 6.517767-126.344406 6.517767m-120.328005 659.297196c-10.5287-78.213204-290.291313-166.955108-447.720454-138.377206 0 0-19.553301-172.470141-27.073801-339.425248-6.517767-143.390873-1.002733-282.770813 0.501366-305.833681C174.475608-6.308547 61.166736 47.337689 0 69.89919c0 0 73.199537 309.844614 126.344406 952.59671 0 0 84.730971 9.0246 230.12731-19.051934s317.365114-115.815705 302.825481-219.097244m-341.932083 140.88404l-24.566967-176.982441c6.0164-3.0082 156.927774 53.144869 172.971507 63.172203-2.506833 11.030067-148.40454 113.810238-148.40454 113.810238" p-id="1845"></path></svg>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MyFooter',
  methods:{
    jumpBili(){
      window.location.href = "https://space.bilibili.com/1168340326";
    }
  }
}
</script>

<style scoped>
.footer{
  height: 200px;
  width: 100vw;
  background-color: #4978f3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.footer .school-logo{
  height: 150px;
  width: 150px;
  margin: 10px;
  transition: transform 500ms;
}
.footer .school-logo:hover{
  transform: scale(110%);
}
.footer-right{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  margin-right: 20px;
}
.footer-right > div{
  margin: 20px 0px;
}
.media-link{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
}
.info-item{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
.info-item > img{
  /*margin: 10px;*/
}
.info-item > p{
  color: white;
  font-family: Arial;
  margin: 0px 3px;
}
.footer-icon-small{
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 500ms;
  margin: 0px 10px;
}
.footer-icon-small > svg{
  width: 30px;
  height: 30px;
  fill: #4978f3;
  transition: all 500ms;
}
.wechat:hover > svg{
  fill: rgb(42, 174, 103);
}
.bilibili:hover > svg{
  fill: #fb7299;
}
.wechat:hover{
  /*position: absolute;*/
  height: 200px;
  width: 200px;
  transform: translateY(-80px);
  background-image: url("https://static.igem.wiki/teams/4152/wiki/erweima.png");
  background-size: contain;
}
.footer-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.footer-icon-small > svg:hover{
  transform: scale(110%);
}
.bk-logo > svg *{
  fill: white;
}
.bk-logo,.aws-logo,.idt-logo{
  /*padding: 25px;*/
  margin: 10px;
}
.aws-logo > svg{
  fill: white;
}
.idt-logo > svg *{
  fill: white;
}
.idt-logo{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.idt-logo > img{
  margin-top: 20px;
  width: 150px;
}

.bk-logo{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.bk-logo > img{
  margin-top: 20px;
  width: 130px;
}
@media screen and (max-width: 840px){
  .footer{
    height: unset;
    flex-direction: column;
  }
  .school-logo{
    height: 100px!important;
    width: 100px!important;
  }
  .footer-right{
    align-items: center;
    margin: 0;
  }
  .info-item{
    justify-content: center;
    max-width: 75vw;
    text-align:justify;
    margin: 10px;
  }
}
</style>